import React from 'react';
import { AppComponent } from 'utils/components';

export default function InfoPanel(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>info panel</div>;
}
